import { render, staticRenderFns } from "./BrowserWarning.vue?vue&type=template&id=44e11cce"
var script = {}
import style0 from "./BrowserWarning.vue?vue&type=style&index=0&id=44e11cce&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports